const normalizeKeyPart = (value) => String(value ?? "").trim();

const getOccurrenceDate = (dateTime) => {
  const rawDateTime = normalizeKeyPart(dateTime);

  if (!rawDateTime) {
    return "";
  }

  // Calendar occurrences are stored with an ISO-style date prefix. Keeping the
  // date portion avoids treating equivalent local/UTC timestamp formats as
  // different cancellations for the same recurring lesson occurrence.
  const isoDatePrefix = rawDateTime.match(/^\d{4}-\d{2}-\d{2}/)?.[0];
  if (isoDatePrefix) {
    return isoDatePrefix;
  }

  const parsedDate = new Date(rawDateTime);
  return Number.isNaN(parsedDate.getTime())
    ? rawDateTime
    : parsedDate.toISOString().slice(0, 10);
};

export const getCancellationOccurrenceKey = (cancellation) =>
  [
    normalizeKeyPart(cancellation?.teacherId),
    normalizeKeyPart(cancellation?.lessonId || cancellation?.id),
    getOccurrenceDate(cancellation?.dateTime),
  ].join("|");

export const deduplicateTimesheetCancellations = (cancellations = []) => {
  const seenOccurrenceKeys = new Set();

  return cancellations.filter((cancellation) => {
    const occurrenceKey = getCancellationOccurrenceKey(cancellation);

    // If legacy data is too incomplete to identify safely, preserve it rather
    // than risk removing a legitimate paid cancellation.
    if (occurrenceKey.split("|").some((part) => !part)) {
      return true;
    }

    if (seenOccurrenceKeys.has(occurrenceKey)) {
      return false;
    }

    seenOccurrenceKeys.add(occurrenceKey);
    return true;
  });
};
